export function formatUtcToLocal(utcString, mode = "both") {
  const date = new Date(utcString);

  // Options for the date part
  const dateOptions = {
    weekday: "short",   // Tue
    month: "short",     // Mar
    day: "numeric",     // 3
    year: "numeric"     // 2026
  };

  // Options for the time part
  const timeOptions = {
    hour: "numeric",    // 9
    minute: "2-digit",  // 00
    hour12: true        // AM/PM
  };

  // Format separately
  const datePart = date.toLocaleDateString(undefined, dateOptions);
  const timePart = date.toLocaleTimeString(undefined, timeOptions);

  // Decide what to return based on mode
  switch (mode) {
    case "date":
      return datePart;
    case "time":
      return timePart;
    case "both":
    default:
      return `${datePart}, ${timePart}`;
  }
}
